'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userExternalAccounts = require('./user-external-accounts.html');

var _userExternalAccounts2 = _interopRequireDefault(_userExternalAccounts);

var _userExternalAccounts3 = require('./user-external-accounts.controller');

var _userExternalAccounts4 = _interopRequireDefault(_userExternalAccounts3);

require('./user-external-accounts.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userExternalAccountsComponent = {
  restrict: 'E',
  bindings: {
    externalAccounts: '<'
  },
  template: _userExternalAccounts2.default,
  controller: _userExternalAccounts4.default,
  controllerAs: 'vm'
};

exports.default = userExternalAccountsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-external-accounts/user-external-accounts.component.js
 **/